export default "__VITE_ASSET__DOcKZr6G__"